// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"201":"3f029ab5","727":"ea049df1","787":"adf0607d"}[chunkId] + ".chunk.js";
};